import axios, { AxiosResponse } from 'axios';
import { parseJwt } from '../../../misc/Helpers';
import { Environment } from '../../../environment';
import { IFormTicketData } from '../../../types/types';


// Criando a instância do Axios
const instance = axios.create({
  baseURL: Environment.URL_BASE,
});

// Interceptor de requisição para verificar a expiração do token
instance.interceptors.request.use(
  function (config) {
    const authHeader = config.headers.Authorization;
    if (typeof authHeader === 'string' && authHeader.startsWith('Bearer ')) {
      const token = authHeader.split(' ')[1];
      const data = parseJwt(token);
      if (Date.now() > data.exp * 1000) {
        window.location.href = '/login';
      }
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);


// Função para criar a autenticação Bearer
function bearerAuth(user: { accessToken: string }): string {
  return `Bearer ${user.accessToken}`;
}

// Funções do serviço
export const TicketsServiceAPI = {
  create,
  quickCreateTicket,
  signup,
  getById,
  getTickets,
  getPartners,
  getOrders,
  getUserMe,
  updateById,
  deleteById,
  deleteUser,
  authenticate,
};

function authenticate(username: string, password: string) {
  return instance.post('/ticket/authenticate', { username, password }, {
    headers: { 'Content-type': 'application/json' },
  });
}

function getPartners(user: { accessToken: string }) {
  const url = '/ticket/getAll';
  return instance.get(url, {
    headers: { 'Authorization': bearerAuth(user) },
  });
}

function signup(user: IFormTicketData) {
  return instance.post('/ticket/signup', user, {
    headers: { 'Content-type': 'application/json' },
  });
}

function create(user: { accessToken: string }, dadosValidados: IFormTicketData) {
  console.log(dadosValidados);

  //TODO ajuste para pegar o valor que vem por fora 
  return instance.post('/ticket/create', dadosValidados, {
    headers: {
      'Content-type': 'application/json',
      'Authorization': bearerAuth(user),
    },
  });
}

function quickCreateTicket(user: { accessToken: string, data: { idUser: string } }) {
  console.log("quickCreateTicket", user);
  return instance.get('/ticket/quickCreateTicket?userId=' + user.data.idUser, {
    headers: {
      'Content-type': 'application/json',
      'Authorization': bearerAuth(user),
    },
  });
}

/*function getTickets(user: { accessToken: string; }, filter : string, page = 1,) {
  const urlRelativa = `/ticket/getAll?_page=${page}&_limit=${Environment.LIMITE_DE_LINHAS}&user=${filter}`;
  //const url = '/ticket/getAll';
  return instance.get(urlRelativa, {
    headers: { 'Authorization': bearerAuth(user) },
  });
} */

function getTickets(user: { accessToken: string }, filter: string, page = 1):
  Promise<{data: {
    content: IFormTicketData[]; totalPages: number; totalElements: number; size: number; number: number; // Número da página atual (0-indexed)
  }}> {
  const urlRelativa = `/ticket/getAll?_page=${page}&_limit=${Environment.LIMITE_DE_LINHAS}&user=${filter}`;
  return instance.get(urlRelativa, {
    headers: { Authorization: bearerAuth(user) },
  });
}

function getById(user: { accessToken: string }, id: string): Promise<AxiosResponse<IFormTicketData>> {
  console.log(id);
  const url = `/ticket/getById/${id}`;
  return instance.get<IFormTicketData>(url, {
    headers: { 'Authorization': bearerAuth(user) },
  });
}

function deleteById(user: { accessToken: string }, id: string): Promise<AxiosResponse<{ id: string }>> {
  const url = `/ticket/deleteById`;
  return instance.post<{ id: string }>(
    url,
    { id }, // Enviando o ID no corpo da requisição
    {
      headers: { Authorization: bearerAuth(user) },
    }
  );
}

function updateById(user: { accessToken: string }, id: string, dados: IFormTicketData): Promise<AxiosResponse<IFormTicketData>> {
  const url = `/ticket/updateById`;

  return instance.post<IFormTicketData>(
    url,
    { ...dados, id }, // Enviando o ID no corpo da requisição
    {
      headers: { Authorization: bearerAuth(user) },
    }
  );
}
/*
function updateById = async (id: number, dados: IFormTicketData): Promise<void | Error> => {
  try {
    await instance.put(`/ticket/updateById${id}`, dados);
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
}; */

function deleteUser(user: { accessToken: string }, username: string) {
  return instance.delete(`/api/users/${username}`, {
    headers: { 'Authorization': bearerAuth(user) },
  });
}

function getOrders(user: { accessToken: string }, text?: string) {
  const url = text ? `/api/orders?text=${text}` : '/api/orders';
  return instance.get(url, {
    headers: { 'Authorization': bearerAuth(user) },
  });
}

function getUserMe(user: { accessToken: string }) {
  return instance.get('/api/users/me', {
    headers: { 'Authorization': bearerAuth(user) },
  });
}
